import type { ExerciseActivity } from "@tandemdiabetes/sugarmate-api-react-client"
import { ExerciseType } from "@tandemdiabetes/sugarmate-api-react-client"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"
import { usePolyglot } from "src/contexts"

interface Props extends ComponentPropsWithoutRef<"div"> {
  activity: ExerciseActivity;
}

export const ExerciseActivityTitle = forwardRef<HTMLDivElement, Props>(
  function ExerciseActivityTitle(props: Props, ref: Ref<HTMLDivElement>) {
    const {
      activity,
      ...htmlDivProps
    } = props

    const polyglot = usePolyglot()

    if (!activity.exercise_type || activity.exercise_type === ExerciseType.None) {
      return null
    }

    return (
      <div
        {...htmlDivProps}
        ref={ref}
      >
        {polyglot.t(`exercise_type.${activity.exercise_type}`)}
      </div>
    )
  },
)
